let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cvmv4")).then(() => parcelRequire('77IPU'));